<template>
  <div class="main-page">
    <div class="left-panel">
      <router-view
        ref="leftPanel"
        @renderMarker="handleRenderMarker"
        @renderPolygon="handleRenderPolygon"
        @markerClick="handleClickMarker"
        @polygonClick="handlePolygonClick"
        @polygonHighlight="handlePolygonHighlight">
      </router-view>
    </div>
    <div class="right-panel">
      <map-com
        ref="mapCom"
        :class="isBlurMap ? 'blur-map':''"
        :marker-list="markerList"
        @markerClick="handleClickMarker"
        @mapMarkerClick="handleMapMarkerClick"
        @polygonClick="handlePolygonClick">
      </map-com>
      <div class="map-cover" v-show="isBlurMap">
        <div class="map-cover__tips">请从左侧面板创建或打开标记集</div>
      </div>
    </div>
  </div>
</template>

<script>
import MapCom from './map/index.vue';

export default {
  data() {
    return {
      markerList: [],
    };
  },
  components: {
    MapCom,
  },
  methods: {
    handleRenderMarker(markerList, disableFit) {
      this.markerList = markerList;
      this.$refs.mapCom.renderMapMarker(markerList, disableFit);
    },
    handleClickMarker(marker) {
      this.$refs.mapCom.setCenter(marker);
    },
    handleMapMarkerClick(marker) {
      this.$refs.leftPanel.showMarker(marker);
    },
    handleRenderPolygon(polygonList, disableFit) {
      this.$refs.mapCom.renderPolygons(polygonList, disableFit);
    },
    handlePolygonClick(polygon) {
      this.$refs.leftPanel.showPolygon(polygon);
    },
    handlePolygonHighlight(polygon) {
      this.$refs.mapCom.setPolygonHighlight(polygon);
    },
  },
  computed: {
    isBlurMap() {
      if (this.$route.name === 'markerList') {
        return false;
      }
      return true;
    },
  },
};
</script>

<style scoped>
.main-page {
  height: 100vh;
  display: flex;
}
.left-panel {
  width: 20vw;
  min-width: 400px;
}
.right-panel {
  flex: 1;
  position: relative;
}

.blur-map {
  filter: blur(10px);
}

.map-cover {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1000;
  background-color: rgba(0, 0, 0, 0.65);
  display: flex;
  align-items: center;
  justify-content: center;
}

.map-cover__tips {
  color: #ffffff;
  font-size: 20px;
}
</style>
